import axios from "axios";

const instance = axios.create({
  // baseURL: "https://stg2.backend.thetalent.games",
  baseURL: "https://backend3.thetalent.games",
  // baseURL: "https://stg-api2.thetalent.games",
  // baseURL:"http://192.168.1.118:3000/"
});

export default instance;
